export default {
	departments(state) {
		return state.geo.departments;
	},
	districts(state) {
		return state.geo.districts;
	},
	provinces(state) {
		return state.geo.provinces;
	},
};



// WEBPACK FOOTER //
// ./src/store/getters/geo.js